import { useFormik } from "formik"
import React, { useEffect, useState } from "react"
import { Col, Form, Input, Row } from "reactstrap"

import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"

import { AutoComplete } from "components/AutoComplete"
import FormSkeleton from "components/FormSkeleton/FormSkeleton"
import TrailerModels from "constants/TrailerModels"
import useAsyncSelect from "hooks/useAsyncSelect"
import { convertToSelectOptions } from "utils/commonUtils"
import {
   GeTrailersTypesListing,
   GetTrailersDetails,
} from "../../../api/api.service"
import { Button } from "../../../components/Button"
import FormikErrorText from "../../../components/FormikErrorText/FormikErrorText"
import { Modal } from "../../../components/Modal"
import { TrailerSize } from "../../../constants"
import {
   FIELDS_NAME,
   initialValues,
   validationSchema,
} from "../ConfiguratorModals/FormConfig"

const TITLES = {
   MODAL_CLONE_TITLE: "Clone Configurator Trailer",
   CLONE_BTN_TEXT: "Clone",
}

const CongfiguratorCloneTrailerModal = ({
   isDetailView = false,
   isOpen = false,
   selectedTrailer,
   onToggleModal = () => {},
   onSuccess = () => {},
   handleClone = () => {},
   id = "",
}) => {
   const [isLoading, setIsLoading] = useState(false)

   const formik = useFormik({
      enableReinitialze: true,
      initialValues: {
         ...initialValues,
      },
      validationSchema: validationSchema,
      onSubmit: values => {
         handleSubmit(values)
      },
   })

   const {
      setSelectedOption: setSelectedTrailerType,
      selectEntity: trailerTypeOptions,
      setSelectEntity: setTrailerTypeOptions,
      handleSearchOnOptions: handleSearchTrailerType,
      selectedOption: selectedTrailerType,
      handleSelectAOption: handleSelectATrailerType,
      handleGetSelectEntityData: getTrailerTypeData,
   } = useAsyncSelect({
      apiFunc: GeTrailersTypesListing,
      labelKey: "trailerType",
      valueKey: "id",
      params: {},
      onOptionSelect: option => {
         formik.setFieldValue([FIELDS_NAME.TRAILER_TYPE], option)
      },
   })

   useEffect(() => {
      handleSetTrailerDetails()
      return () => {
         setIsLoading(false)
      }
   }, [id])

   const handleSubmit = values => {
      if (!selectedTrailer?.id) return

      const payload = {
         trailerId: selectedTrailer?.id,
         // trailerTypeId: values?.trailerType?.value,
         configuratorTrailerSizeType: values?.size,
         model: [values?.model?.value],
      }
      handleClone(payload, setIsLoading)
      onSuccess()
   }

   const handleSetTrailerDetails = () => {
      if (!selectedTrailer?.id) return

      setSelectedTrailerType({
         label: selectedTrailer?.trailerType?.trailerType,
         value: selectedTrailer?.trailerType?.id,
      })

      formik.setValues({
         [FIELDS_NAME.MODEL_NAME]: {
            label: selectedTrailer?.model[0],
            value: selectedTrailer?.model[0],
         },

         [FIELDS_NAME.SIZE]: selectedTrailer?.configuratorTrailerSizeType,
         [FIELDS_NAME.TRAILER_TYPE]: {
            label: selectedTrailer?.trailerTypeId,
            value: selectedTrailer?.trailerTypeId,
         },
      })
   }

   const handleModalClose = () => {
      setTimeout(() => {
         formik.resetForm()
         setSelectedTrailerType(null)
         onToggleModal()
      }, 20)
   }

   const handleCheckboxChange = (e, fieldName) => {
      const { value } = e.target
      formik.setFieldValue(fieldName, [value])
   }

   return (
      <Modal
         isOpen={isOpen}
         handleModalToggling={handleModalClose}
         bodyClassName=""
         customButton={true}
         hideModalHeaderSeparator={true}
         headerClasses="header-container"
         sizeClasses="2"
         backdrop="static"
         modalTitle={TITLES.MODAL_CLONE_TITLE}
         scrollable
      >
         <div
            style={{ pointerEvents: isLoading ? "none" : "auto" }}
            className="mx-4"
         >
            <Row>
               <Col xs={12}>
                  <Form onSubmit={formik.handleSubmit}>
                     {/* <Row className="mb-3 align-items-center">
                        <div className="col-md-12">
                           <>
                              <small
                                 style={{
                                    fontWeight: 500,
                                    fontSize: "0.8rem",
                                 }}
                              >
                                 Trailer Type
                              </small>

                              <AutoComplete
                                 handleBlur={() => {
                                    setTrailerTypeOptions(prev => ({
                                       ...prev,
                                       page: 1,
                                       Q: "",
                                       data: [],
                                    }))
                                    getTrailerTypeData(1)
                                 }}
                                 handleScroll={() => {
                                    if (trailerTypeOptions?.isDataAvailable) {
                                       getTrailerTypeData(
                                          trailerTypeOptions?.page
                                       )
                                    }
                                 }}
                                 onChange={handleSelectATrailerType}
                                 onInputChange={handleSearchTrailerType}
                                 placeholder="Search trailer types"
                                 classNamePrefix="add-new-req"
                                 customStyles={autoCompleteStyles.STYLE_NINE}
                                 options={trailerTypeOptions?.data}
                                 value={selectedTrailerType}
                                 isLoading={trailerTypeOptions?.fetching}
                                 name={FIELDS_NAME.TRAILER_TYPE}
                              />
                              <FormikErrorText
                                 formikInstance={formik}
                                 fieldName={FIELDS_NAME.TRAILER_TYPE}
                              />
                           </>
                        </div>
                     </Row> */}

                     <Row className=" mb-3 align-items-center">
                        <Col md={12}>
                           <Row>
                              <Col sm={12}>
                                 <small
                                    style={{
                                       fontWeight: 500,
                                       fontSize: "0.8rem",
                                    }}
                                 >
                                    Model Name
                                 </small>

                                 <>
                                    <AutoComplete
                                       name={FIELDS_NAME.MODEL_NAME}
                                       value={
                                          formik.values[FIELDS_NAME.MODEL_NAME]
                                       }
                                       placeholder="Select model"
                                       isSearchable={false}
                                       classNamePrefix="add-new-req"
                                       customStyles={
                                          autoCompleteStyles.STYLE_FOUR
                                       }
                                       options={convertToSelectOptions(
                                          TrailerModels
                                       )}
                                       onChange={val =>
                                          formik.setFieldValue(
                                             FIELDS_NAME.MODEL_NAME,
                                             val
                                          )
                                       }
                                    />
                                    <FormikErrorText
                                       formikInstance={formik}
                                       fieldName={FIELDS_NAME.MODEL_NAME}
                                    />
                                 </>
                              </Col>
                           </Row>
                        </Col>
                     </Row>

                     <Row className="mt-4 mb-3 align-items-center">
                        <div className="col-md-12">
                           <small
                              style={{
                                 fontWeight: 500,
                                 fontSize: "0.8rem",
                              }}
                           >
                              Size
                           </small>

                           <div className="d-flex">
                              {Object.keys(TrailerSize).map(sizeKey => (
                                 <div
                                    key={sizeKey}
                                    className="d-flex align-items-center"
                                 >
                                    <Input
                                       type="checkbox"
                                       name={FIELDS_NAME.SIZE}
                                       value={TrailerSize[sizeKey]}
                                       checked={
                                          formik.values[FIELDS_NAME.SIZE][0] ===
                                          TrailerSize[sizeKey]
                                       }
                                       onClick={e =>
                                          handleCheckboxChange(
                                             e,
                                             FIELDS_NAME.SIZE
                                          )
                                       }
                                    />
                                    <span className="mx-2">
                                       {TrailerSize.getDisplayTextKey(
                                          TrailerSize[sizeKey]
                                       )}
                                    </span>
                                 </div>
                              ))}
                           </div>

                           <FormikErrorText
                              formikInstance={formik}
                              fieldName={FIELDS_NAME.SIZE}
                           />
                        </div>
                     </Row>

                     <div className="d-flex justify-content-center mt-3 mt-2">
                        <Button
                           isLoading={isLoading}
                           type={"submit"}
                           title={TITLES.CLONE_BTN_TEXT}
                           className="header-button"
                        />
                     </div>
                  </Form>
               </Col>
            </Row>
         </div>
      </Modal>
   )
}

export default React.memo(CongfiguratorCloneTrailerModal)
